import { render, staticRenderFns } from "./SignUpConfirmation.vue?vue&type=template&id=87c0ba42&scoped=true&"
import script from "./SignUpConfirmation.vue?vue&type=script&lang=js&"
export * from "./SignUpConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SignUpConfirmation.vue?vue&type=style&index=0&id=87c0ba42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c0ba42",
  null
  
)

export default component.exports